export default function getTopThreshold(): number
{
    return 0;
}
